import React, { memo } from 'react';
import classNames from 'classnames';
import cls from './VisualizationsList.module.css';
import { useVisualizationsList } from './useVisualizationsList';
import { Visualization } from '../../../../types/dashboardInformation';
import { VisualizationsImage } from '../VisualizationsImage/VisualizationsImage';

interface VisualizationsListProps {
    classes?: string;
    visualizations: Visualization[];
}

export const VisualizationsList = memo(({ classes, visualizations }: VisualizationsListProps) => {
    const {} = useVisualizationsList();

    return (
        <div className={classNames(cls.VisualizationsList, [classes])}>
            {visualizations.map((visualization) => (
                <VisualizationsImage key={visualization.id} id={visualization.id} />
            ))}
        </div>
    );
});
